<template>
    <div class="animated fadeIn">
        <CForm
                ref="form"
                v-if="dataFormStructures.recurringSubscription.rows !== undefined"
                :structure="dataFormStructures.recurringSubscription">
            <template v-for="row, rowIndex in dataFormStructures.recurringSubscription.rows">
                <template v-for="col, colIndex in row.cols">
                    <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                            <slot :name="card.key"></slot>
                        </slot>
                    </template>
                </template>
            </template>
        </CForm>
    </div>
</template>

<script>
    var _self;
    import CForm from '../components/CForm'
    import ModalConfirm from '../components/ModalConfirm'
    export default {
        name: 'FormRecurringSubscription',
        components: {
            CForm,
            ModalConfirm
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFieldRefs: [],
                dataFormStructures: {
                    recurringSubscription: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement récurrent'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productRecurringSubscriptionSummary'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'bookingSummary'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'payments'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(Mantle.Subscription.statusActivated, Mantle.Subscription.statusOptions()),
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'payments',
                                type: 'payments',
                                calcTotalOnEval: true,
                                displayMakePayment: false,
                                displayCheckPayment: true,
                                displayCompletedPayment: false,
                                displayPaymentStatus: false,
                                options: {displayAddNewPayment: false},
                                instance: Core.Product.typeRecurringSubscription,
                                instanceId: 0,
                                total: 0,
                                forceTotal: false,
                                onTokenizationSuccess() {},
                                onPaymentCompleted() {},
                                onCheckPayment(payments, fieldRefs) {
                                    _self.dataFieldRefs = fieldRefs
                                    _self.$emit('onCheckPayment', payments)
                                }
                            },
                            {
                                id: 'productRecurringSubscriptionSummary',
                                type: 'productRecurringSubscriptionSummary',
                                value:  {
                                    recurringSubscriptionProductId: '',
                                    title: '',
                                    shortDescription: '',
                                    productId: '',
                                    amount: '0',
                                    periodInterval: Core.Select.select(Core.Product.periodIntervalOne, window.Core.Product.periodIntervalOptions()),
                                    period: Core.Select.select(Core.Product.periodMonth, window.Core.Product.periodOptions()),
                                    periodLength: '0',
                                    periodPaymentLength: '0',
                                    bookingLimitManagement: false,
                                    bookingLimit: '0',
                                    bookingLimitPeriod: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    start: null,
                                    end: null
                                },
                                onEvalPayments: function(dates, value, form, fieldRefs) {
                                    for(let date in dates) {
                                        date = dates[date]
                                        if (!fieldRefs['payments'].dateHasPayment(date)) {
                                            fieldRefs['payments'].addPayment(date, Core.Payment.statusWaiting, Core.Payment.methodCC, value.amount, '')
                                        }
                                    }
                                }
                            },
                            {
                                id: 'bookingSummary',
                                type: 'bookingSummary',
                                value: []
                            }
                        ]
                    }
                }
            }
        },
        methods: {
        }
    }
</script>
